<div class="editor-container">
    <div #editor id="editor" class="editable-content fs-16" [ngClass]="{'content-height': !isPost}" contenteditable="true" (mouseup)="saveSelection()"
        (keyup)="saveSelection()" (input)="emitChange()" (blur)="onBlur()" [attr.data-placeholder]="'write_here' | translate">
    </div>

    <div class="toolbar-wrapper d-flex justify-content-end align-items-center gap-0" *ngIf="isBrowser && !isPost">
        <div class="toolbar bdr-black rounded-5 d-flex align-items-center flex-wrap  p-1" *ngIf="showEditor">
            <select class="form-select form-select-sm w-auto border-0 syne-text" (mousedown)="saveSelection()"
                (change)="applyFontSize($event)">
                <option value="1">1pt</option>
                <option value="2">2pt</option>
                <option value="3">3pt</option>
                <option value="4">4pt</option>
                <option value="5">5pt</option>
                <option value="6">6pt</option>
                <option value="7">7pt</option>
            </select>
            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('bold')" data-tooltip="Bold">
                <i class="fa-solid fa-bold"></i>
            </button>

            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('italic')" data-tooltip="Italic">
                <i class="fa-solid fa-italic"></i>
            </button>

            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('underline')" data-tooltip="Underline">
                <i class="fa-solid fa-underline"></i>
            </button>

            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('strikeThrough')" data-tooltip="Strikethrough">
                <i class="fa-solid fa-strikethrough"></i>
            </button>

            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('justifyLeft')" data-tooltip="Align Left">
                <i class="fa-solid fa-align-left"></i>
            </button>
            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('justifyCenter')" data-tooltip="Align Center">
                <i class="fa-solid fa-align-center"></i>
            </button>
            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('justifyRight')" data-tooltip="Align Right">
                <i class="fa-solid fa-align-right"></i>
            </button>
            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="exec('justifyFull')" data-tooltip="Justify">
                <i class="fa-solid fa-align-justify"></i>
            </button>

            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)"
                (click)="exec('insertUnorderedList')" data-tooltip="Unordered List">
                <i class="fa-solid fa-list-ul"></i>
            </button>
            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)"
                (click)="exec('insertOrderedList')" data-tooltip="Ordered List">
                <i class="fa-solid fa-list-ol"></i>
            </button>

            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="insertLink()" data-tooltip="Insert Link">
                <i class="fa-solid fa-link"></i>
            </button>
            <button class="btn btn-light btn-sm" (mousedown)="keepSelection($event)" (click)="removeLink()" data-tooltip="Remove Link">
                <i class="fa-solid fa-unlink"></i>
            </button>
        </div>
        <div class="p-1">
            <button class="btn btn-outline-primary d-flex justify-content-center align-items-center bdr-black"
                (click)="toggleEditor()">
                <i class="skf-text-size"></i>
            </button>
        </div>
    </div>
</div>